import { z } from "zod";

/**
 * Speech to text configuration
 */
export const PhoneCallSpeechToTextSchema = z.object({
  provider: z.string(),
  multilingual: z.boolean()
});

export type PhoneCallSpeechToText = z.infer<typeof PhoneCallSpeechToTextSchema>;
